import { HtmlAdapterV2 } from './htmlController-v2';
import { HtmlAdapterV3 } from './htmlController-v3';
import { GridController } from './gridController';

import type { Engine } from "../engine";
import type { Resource } from '@reporting/rp-types/generated/ext';

export * from './extensionController';

export const createController = (engine: Engine, resource: Resource) => {
	if (/.sheet$/i.test(resource.name)) {
		return new GridController(engine);
	} else if (engine.version === '3') {
		return new HtmlAdapterV3(engine);
	} else {
		return new HtmlAdapterV2(engine);
	}
}
